export default __webpack_public_path__ + "static/media/Icono_Avatar.309f8868.png";